import React, { useState, useEffect } from 'react';
import styled from 'styled-components'; 
import FitgroupChangestep1 from './fitgroupdetail/FitgroupChangestep1';
import FitgroupChangeStep2 from './fitgroupdetail/FitgroupChangeStep2';
import ChangeTitle from '../../peoplelist/ChangeTitle';
import Modalback from '../../modal/Modalback';
import serverController from '../../../server/serverController';
import { Link, useHistory } from 'react-router-dom';
import appInfoContainer from '../../../auth/appInfoContainer';

export default function FitgroupmakeChage({ match }) {
  const [showModal, setShowModal] = useState(false);
  const [fitIntroductContent, setFitIntroductContent] = useState('');
  const [screenIndex, setScreenIndex] = useState(0);

  const [fitImg, setFitImg] = useState(null);
  const [fitName, setFitName] = useState('');
  const [fitinfo, setFitinfo] = useState('');
  const [publics, setPublics] = useState(null);
  const [newCoverImg, setNewCoverImg] = useState(null);

  const [groupInfo, setGroupInfo] = useState({});
  const infoCallBack = (jsonData) => {
    if (jsonData.success != 1) {
      alert('서버에 문제가 있습니다.');
      return;
    }
    let isPublic = jsonData.data.visibility === 'private' ? true : false;
    let coverImg =
      appInfoContainer.imagePath +
      '/group_cover_img/' +
      jsonData.data.group_cover_img;
    setFitName(jsonData.data.title);
    setFitImg(coverImg);
    setFitinfo(jsonData.data.description);
    setPublics(isPublic);
    setGroupInfo(jsonData.data);
  };

  const history = useHistory();
  //페이지가 렌더링이 되었을 때 한번 호출
  useEffect(() => {
    serverController.getServerData(`groups/${match.params.id}`, infoCallBack);
  }, []);

  const callBack = (res) => {
    if (res.success == 1) {
      window.location.reload();
      history.goBack();
      //serverController.getServerData("auth",test);
    } else {
      alert('실패');
    }
  };

  // const imageSendCallBack =(data)=>{
  //     var imagePathArray = [];
  //     data.data.upload_results.map((value)=>{ imagePathArray.push(value.file_name); });

  //     let serverData = {
  //         title : fitName,
  //         description : fitinfo,
  //         visibility  : publics ? "private":"public",
  //         group_cover_img : imagePathArray.pop(),
  //     };
  //     serverController.generalPutFetchController(`groups/${match.params.id}`,JSON.stringify(serverData),callBack);
  // }

  /*--click block--*/
  let isclick = false;
  const submitUpdate = async (data) => {
    let imagePathArray = [];
    if (data && data.data && data.data.upload_results) {
      data.data.upload_results.map((value) => {
        imagePathArray.push(value.file_name);
      });
    }

    let form = {};
    form['title'] = fitName;
    form['description'] = fitinfo;
    form['visibility'] = 'public';
    if (imagePathArray.length > 0) {
      form['group_cover_img'] = imagePathArray.pop();
    }
    await serverController.updateFilePutFetchController(
      `groups/${match.params.id}`,
      JSON.stringify(form),
      callBack,
    );
    isclick = false;
  };
  const submitImg = async () => {
    if (isclick) return;
    isclick = true;

    if (newCoverImg !== null) {
      var formData = new FormData();
      formData.append('file', newCoverImg);
      formData.append('path', 'group_cover_img/');
      await serverController.updatefilePostFetchController(
        `file`,
        formData,
        submitUpdate,
      );
    } else {
      submitUpdate();
    }
  };
  const updateNext = (index) => {
    // 페이지 더 생성되면 숫자 늘려나가기
    if (screenIndex + index == -1 || screenIndex + index > 1) return;
    setScreenIndex(screenIndex + index);
  };

  const Closeclick = () => {
    alert('확인');
    setShowModal(false);
  };

  let renderPageController = () => {
    switch (screenIndex) {
      case 0:
        return (
          <FitgroupChangestep1
            updateNext={updateNext}
            titname={'모임 이름'}
            fitImg={fitImg}
            setFitImg={setFitImg}
            setNewCoverImg={setNewCoverImg}
            fitName={fitName}
            setFitName={setFitName}
            placeholder={'ex) 강남구 직장인 다이어터 모임'}
            groupInfo={groupInfo}
          />
        );
      case 1:
        return (
          <FitgroupChangeStep2
            // fitIntroductContent={fitIntroductContent}
            // setFitIntroductContent={setFitIntroductContent}
            updateNext={updateNext}
            infotext={
              '본인 모임에 대한 간단한 소개 및 주의사항 / 가이드라인을 제시해 주세요'
            }
            dataSubmit={submitImg}
            fitinfo={fitinfo}
            setFitinfo={setFitinfo}
            publics={publics}
            setPublics={setPublics}
            groupInfo={groupInfo}
          />
        );
      //  updateNext={updateNext} 넘기는게 중요!!!
    }
  };

  return (
    <Fitgroupinner>
      <ChangeTitle
        title={'모임 수정'}
        borderbottom={'solid 1px #d5d5d5'}
        setShowModal={setShowModal}
      />
      {renderPageController()}
      <Modalback
        setShowModal={setShowModal}
        showModal={showModal}
        title={'모임 생성 취소'}
        subtitle={'내가 작성한 모임이 취소됩니다. 취소 하시겠어요? '}
        submitClick={Closeclick}
      />
    </Fitgroupinner>
  );
}

const Fitgroupinner = styled.div`
  padding-bottom: calc(100vw * (120 / 375));
`;
